<template>
  <div class="new-content new-content_event">
    <TextareaAutosize
      class="new-title"
      type="text"
      v-model="title"
      placeholder="Введите название места"
    />
    <div v-if="blocks">

    <block
      v-for="(block, index) in getBlocks"
      :key="'block-' + index"
      :block="block"
      :index="index"
      :navigation="blocks.length > 1"
      :path="'places'"
      :addMore="addMoreImages"
      @click="deleteBlock(index)"
      @changeType="changeType"
      @changeValue="changeValue"
      @deleteBlock="deleteBlock"
      @moveUp="moveUpBlock"
      @moveDown="moveDownBlock"
    />
    <div class="new-block new-block_adder" v-if="addMoreBlocks">
      <div class="new-block-type visible">
        <div class="new-block-type__item active" @click="blocks.push({ type: 'paragraph', value: '' })">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#2E3A59"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M5 6.41L10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41 17.59 5 12 10.59 6.41 5 5 6.41z"
            />
          </svg>
        </div>
        <div class="new-block-type__item" @click="blocks.push({ type: 'paragraph', value: '' })">
          <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
            <path d="M15 19H3v-2h12v2zm6-4H3v-2h18v2zm-6-4H3V9h12v2zm6-4H3V5h18v2z" />
          </svg>
        </div>
        <div class="new-block-type__item" @click="blocks.push({ type: 'image', value: [] })" v-if="addMoreImages">
          <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
            <path
              d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2zM5 5v14h14V5H5zm13 12H6l3-4 1 1 3-4 5 7zm-9.5-6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
            />
          </svg>
        </div>
        <div
        class="new-block-type__item"
        @click="blocks.push({ type: 'h3', value: '' })"
      >
        <p>H</p>
      </div>
      <div
        class="new-block-type__item"
        @click="blocks.push({ type: 'youtube', value: '' })"
      >
        <p>Y</p>
        
      </div>
      </div>
    </div>
    </div>
    <div class="new-string">
      <!-- <h3 class="new-subtitle">Выберите категории спорта</h3> -->
      <div class="new-sports">
        <div class="map-button map-button_rainbow" @click="changeState('sports_new')">
          <p>Выберите виды спорта</p>
        </div>

        <Sports :sports="getActiveSports" />
      </div>
    </div>

    <choise-icons @changeIcon="changeIcon" />

    <block-place :active_point="position" :exclude_place="place" @setPlace="setPlace" @setPosition="setPosition" />
    
    <div class="new-filters">
      <div class="new-filters__checkbox">
        <input id="cover" class="checkbox" type="checkbox" v-model="isprivate" />
        <label for="cover">Личное место (не будет показываться в списке мест)</label>
      </div>
    </div>
    <block-cover v-if="place" :active_cover="cover" @changeCover="changeCover" :path="'places_covers'" />
    <div class="new-footer">
      <div class="new-publish" @click="publish()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="white"
          viewBox="0 0 24 24"
        >
          <path
            d="M9.525 17.657l-4.95-4.95 1.414-1.414 3.537 3.534-.001.001 8.485-8.485 1.414 1.414-8.485 8.486-1.413 1.413-.001.001z"
          />
        </svg>
        <p>Редактировать</p>
      </div>
    </div>
    <ModalAddUser />
    <SportsWindowNew v-if="showSports" />
  </div>
</template>
<script>
import Block from './Block';
import ModalAddUser from '@/components/Modals/ModalNewAddUser'
import SportsWindowNew from '@/components/Filters/SportsWindowNew.vue';
import Sports from '@/components/Filters/SportsNew.vue';
import ChoiseIcons from './ChoiseIcons';
import BlockPlace from './BlockPlace';
import BlockCover from './BlockCover.vue';

export default {
  name: 'EditPlace',
  props: {
      place: {
          type: Object,
          require: true
      }
  },
  data: () => {
    return {
      title: null,
      blocks: null,
      isprivate: false,
      text: null,
      position: null,
      cover: null,
      region: null,
      icon: null,
      sports_forget: true,
      loading: false
    };
  },
  computed: {
    showSports () {
			return this.$store.getters.sports_new;
    },
    getBlocks() {
      return this.blocks
    },
    getActiveSports() {
      return this.$store.getters.getActiveSportsNew;
    },
    getUser() {
      return this.$store.getters.getAuthUser;
    },
    addMoreBlocks() {
      return this.blocks.length < 13
    },
    addMoreImages() {
      let sum = 0;
      this.blocks.forEach(block => {
        block.type == 'image' ? sum += block.value.length : ''; 
      })
      return sum < 6
    }
  },
  components: {
    Block,
    ModalAddUser,
    SportsWindowNew,
    Sports,
    BlockPlace,
    BlockCover,
    ChoiseIcons
  },
  methods: {
      changeIcon(data) {
      this.icon = data
    },
    moveUpBlock(index) {
      if (index > 0) {
        let blocks = this.blocks; 
        let block = blocks[index];
        blocks[index] = blocks[index - 1];
        blocks[index - 1] = block;
        this.blocks = [].concat(blocks)
      }
    },
    moveDownBlock(index) {
      if (index < this.blocks.length - 1) {
        let blocks = this.blocks;
        let block = blocks[index];
        blocks[index] = blocks[index + 1];
        blocks[index + 1] = block;
        this.blocks = [].concat(blocks)
      }
    },
    changeType(data) {
      this.blocks[data.index].type = data.type;
      this.blocks[data.index].value = data.type === 'image' ? [] : '';
    },
    changeCover(cover) {
      this.cover = cover;
    },
    changeValue(data) {
      this.blocks[data.index].value = data.value;
    },
    deleteBlock(data) {
      this.$delete(this.blocks, data);
    },
    async publish() {
      let author = {
        id: this.getUser.id,
        firstname: this.getUser.firstname,
        lastname: this.getUser.lastname,
        avatar: this.getUser.avatar,
      };
      let data = {
        id: this.place.id,
        type: 'place',
        title: this.title,
        content: this.blocks,
        author: author,
        isprivate: this.isprivate,
        position: this.position,
        sports: this.getActiveSports,
        cover: this.cover,
        icon: this.icon,
        region: null
      };

      let sum_content = Number();
      data.content.forEach((element) => {
        sum_content += element.value.length;
      });

      if (!data.title) {
        this.$store.dispatch('addError', { message: 'Не введено название места' });
      } else if (sum_content === 0) {
        this.$store.dispatch('addError', { message: 'Вы не заполнили поле контента' });
      } else if (!data.position) {
        this.$store.dispatch('addError', {
          message: 'Поставьте точку на карте',
        });
      } else if (!data.cover) {
        this.$store.dispatch('addError', { message: 'Добавьте обложку' });
      } else if (data.sports.length < 1 && !this.sports_forget) {
        this.sports_forget = false
        this.$store.dispatch('addNotification', { message: 'Не забыли добавить категории спорта?' });
      } else if (!data.author) {
        this.$store.dispatch('addError', { message: 'Ошибка аутентификации' });
      } else {
        this.loading = true;
        if (data.place && this.region) {
          this.createPlace(data)
        } else {
          this.$axios.post('/api/zones/by_coords', {coords: data.position})
            .then( res => {
              data.region = {
                country: res.data.country,
                state: res.data.state,
                country_code: res.data.country_code, 
                state_code: res.data.state_code
              };
              this.createPlace(data)
            })
        }
      }
    },

    async createPlace(data) {
      await this.$store.dispatch('updatePlace', {place: data});
      this.loading = false;
      let place = await this.$store.dispatch('fetchPlace', { id: this.place.id });
      this.$router.push({ name: 'place', params: { hash: place.id + '&' + place.hash } });
      this.$store.dispatch('addNotification', { message: 'Ваше место редактировано!' });
      this.$store.dispatch('editPlace', null)
      this.clearData()
    },

    changeState(element) {
      this.$store.dispatch('changeState', { element: element, val: true });
    },
    setPlace(place) {
      this.map_place = place.id;
    },
    setPosition(position) {
      this.position = position;
    },
    clearData() {
      this.$store.dispatch('clearNewInvites')
      this.$store.dispatch('editPlace', null)
    }
  },
  mounted () {
    this.title = this.place.title;
    this.position = {latitude: this.place.latitude, longitude: this.place.longitude};
    this.blocks = this.place.content || [
        {
          type: 'paragraph',
          value: null,
        },
      ];
    this.icon = this.place.icon
    this.cover = this.place.cover;
  }
};
</script>
